import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import vuexpersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {},
  state,
  getters,
  mutations,
  actions,
  plugins:[vuexpersistedstate({})]
})



// WEBPACK FOOTER //
// ./src/store/index.js